import { ChannelSettingSectionHeader } from './ChannelSettingSectionHeader';
import type { DBCategory } from '@core/types/types.db';
import { Checkbox } from '@frontend/components/ui/checkbox';
import { Label } from '@frontend/components/ui/label';
import {
  RadioGroup,
  RadioGroupItem,
} from '@frontend/components/ui/radio-group';

type SelectionType = 'all' | 'none' | 'specific';

export function ChannelCategorySourceSection({
  selectionType,
  selectedCategories,
  categories,
  onSelectionTypeChange,
  onCategoryToggle,
  isReadOnly = false,
}: {
  selectionType: SelectionType;
  selectedCategories: string[];
  categories: DBCategory[] | undefined;
  onSelectionTypeChange: (type: SelectionType) => void;
  onCategoryToggle: (categoryId: string, checked: boolean) => void;
  isReadOnly?: boolean;
}) {
  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <ChannelSettingSectionHeader
          title="Answer Source Categories"
          description="Choose which categories the answer bot should use to answer questions in this channel"
        />
      </div>

      <RadioGroup
        value={selectionType}
        disabled={isReadOnly}
        onValueChange={(value) =>
          !isReadOnly && onSelectionTypeChange(value as SelectionType)
        }
      >
        <div className="flex flex-col gap-3">
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="all" id="cat-all" disabled={isReadOnly} />
            <Label htmlFor="cat-all" className="text-sm font-normal">
              All categories (default)
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="none" id="cat-none" disabled={isReadOnly} />
            <Label htmlFor="cat-none" className="text-sm font-normal">
              No categories (disable Answer Bank)
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem
              value="specific"
              id="cat-specific"
              disabled={isReadOnly}
            />
            <Label htmlFor="cat-specific" className="text-sm font-normal">
              Specific categories only
            </Label>
          </div>
        </div>
      </RadioGroup>

      {selectionType === 'specific' && categories && categories.length > 0 && (
        <div className="mt-3 pl-6">
          <p className="mb-2 text-xs text-gray-600">
            Select categories to use:
          </p>
          <div className="flex flex-col gap-2">
            {categories.map((category) => (
              <div key={category.id} className="flex items-center gap-2">
                <Checkbox
                  id={`category-${category.id}`}
                  checked={selectedCategories.includes(category.id)}
                  disabled={isReadOnly}
                  onCheckedChange={(checked) =>
                    !isReadOnly &&
                    onCategoryToggle(category.id, checked === true)
                  }
                />
                <Label
                  htmlFor={`category-${category.id}`}
                  className="cursor-pointer text-sm font-normal"
                >
                  {category.name}
                </Label>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
